
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/desktop",
      function () {
        return require("private-next-pages/home/desktop/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/desktop"])
      });
    }
  